var exports = {
  "p": "x04b3a21e--7e5498--list",
};

module.exports = exports;
